import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Recurso, StatusRecurso } from '../../model/Candidato/Recurso';

interface JulgarRecursoModal {
    recurso: Recurso;
    show: boolean;
    onHide: () => void;
    onConfirm: (status: StatusRecurso) => void;
}

const formatarData = (data: string | null): string | null => {
    if (!data) return null;

    const partes = data.split('T')[0].split('-');
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
};


const JulgarRecursoModal: React.FC<JulgarRecursoModal> = ({ recurso, show, onHide, onConfirm }) => {
    const [statusSelecionado, setStatusSelecionado] = useState<StatusRecurso>(recurso.status);

    const handleConfirmar = () => {
        onConfirm(statusSelecionado);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Julgar Recurso</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><strong>Texto:</strong> {recurso.texto}</p>
                <p><strong>Data de Criação:</strong> {formatarData(recurso.dataCriacao)}</p>
                <Form>
                    <Form.Group>
                        <strong>
                            <Form.Label>Status:</Form.Label>
                            <Form.Check
                                type="radio"
                                label="Aceito"
                                value={StatusRecurso.ACEITO}
                                checked={statusSelecionado === StatusRecurso.ACEITO}
                                onChange={() => setStatusSelecionado(StatusRecurso.ACEITO)}
                                style={{marginTop: '8px', color:'darkgreen'}}
                            />
                            <Form.Check
                                type="radio"
                                label="Recusado"
                                value={StatusRecurso.RECUSADO}
                                checked={statusSelecionado === StatusRecurso.RECUSADO}
                                onChange={() => setStatusSelecionado(StatusRecurso.RECUSADO)}
                                style={{marginTop: '8px', color:'darkred'}}
                            />
                        </strong>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
                <Button variant="primary" onClick={handleConfirmar}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default JulgarRecursoModal;